import React, { useContext } from 'react';
import { ViewModelForm, ViewModelServiceContext } from '@xengage/gw-portals-viewmodel-react';
import { useAuthentication } from '@xengage/gw-digital-auth-react';
import { MLRatingFactorComponent } from 'ml-capability-quoteandbind-common-react';
import { MLLocalDateUtil } from 'ml-portals-util-js';
import MLPolicySummaryDetailsComponent from '../../Components/MLPolicySummaryDetailsComponent/MLPolicySummaryDetailsComponent';

import metadata from './RiskAnalysis.metadata.json5';

const RiskAnalysis = (props) => {

    const {
        policyDetailsData: {
            policyResponse: policy
        }
    } = props;
    const { authHeader } = useAuthentication();
    const viewModelService = useContext(ViewModelServiceContext);

    const getCurrentTermPolicies = () => {
        const policies = [];
        const periodsOrderedFromLast = _.orderBy(policy.periods, ['createTime_ML'], ['desc']);
        const flteredPeriods = periodsOrderedFromLast.find((period) => {
            const currentDate = new Date().setHours(0, 0, 0, 0);
            return currentDate >= MLLocalDateUtil.localDate2Date(period.effective_ML) && currentDate <= MLLocalDateUtil.localDate2Date(period.expiration_ML) 
        }) || policy.latestPeriod;
        policies.push(flteredPeriods);
        return policies;
    };

    const overrideProps = {
        policySummaryDetailsComponent: {
            policies: getCurrentTermPolicies(),
            dtoInfo: 'edge.capabilities.gateway.policy.dto.PolicyPeriodDTO',
            totalFees: policy.totalChanges_Ext,
            itemizedFees: policy.feesCosts_Ext,
            displayAlternativeTemplate: false
        },
        ratingFactors: {
            jobOrPolicyNumber: props.fromAccountLanding.policyDetailsData.policyResponse.policyNumber,
            isPolicy: true,
            authHeader,
            viewModelService,
            policies: getCurrentTermPolicies(),
            isModernProduct : policy?.latestPeriod?.isModernProduct_Ext
        }
    }

    const resolvers = {
        resolveComponentMap: {
            MLRatingFactorComponent,
            MLPolicySummaryDetailsComponent
        }
    }
   
    return (
        <ViewModelForm 
            uiProps={metadata.pageContent}
            overrideProps={overrideProps}
            componentMap={resolvers.resolveComponentMap}
        />
    )
};

export default RiskAnalysis;